<p>list-redin-rewards works!</p>
